import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import MUITable from "../../common/components/mui-table/mui-table";
import _ from "lodash";
import { AlertComponent, BreadcrumbComponent } from "../../common/components";
import { Box, Checkbox, Tooltip, Typography } from "@mui/material";
import LeadsStatus from "./leads-status"; // Custom badge component
import "./lead-list.scss";
import LeadFilter from "./lead-filter/lead-filter";
import LeadFilterOptions from "./lead-filter/lead-filter-options";
import { filterOptions } from "./lead-filter/lead-filter.constant";
import CreateLeadPopup from "./voice-create-lead/create-lead-popup/create-lead-popup";
import CreateLead from "./voice-create-lead/create-lead/create-lead";
import PaginationComponent from "../../common/components/pagination-component/pagination-component";
import { getLeads } from "../../api/lead";
import { useLogin } from "../../common/hooks/useUser";
import { useSetLoading } from "../../common/hooks/appearance";
import LeadView from "./lead-view/lead-view";
import { breadcrumbLink } from "./lead-list.constant";
import MassDelete from "./lead-actions/mass-delete";
import { useLocation } from "react-router-dom";
import { actionsOptions } from "./lead-filter/lead-filter.constant";
import LeadActionHandler from "./lead-actions";
import { routes } from "../../constants/routes";
import { useMediaQuery } from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import CreateLeadResponsive from "./voice-create-lead/create-lead-responsive/create-lead-responsive";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}
const LeadList: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedLeads, setSelectedLeads] = useState<number[]>([]);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [selectedLeadsFilter, setSelectedLeadsFilters] = useState<number[]>([]);
  const [selectedAllLeads, setSelectedAllLeads] = useState<any>(null);
  const [selectedCreateLeads, setSelectedCreateLeads] = useState<any>(null);
  const [selectedActions, setSelectedActions] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState<number>(0); // Set an initial value for testing
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(15);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLink);
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [selectedLeadId, setSelectedLeadId] = useState<any>(null);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [sortOption, setSortOption] = useState<SortOption>({
    sortDirection: null,
    sortBy: null,
  });
  const [selectedLeadActionScope, setselectedLeadActionScope] =
    useState<string>("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [isShowCreateLead, setIsShowCreateLead] = useState<boolean>(false);
  const [isShowCreateLeadSection, setIsShowCreateLeadSection] =
    useState<boolean>(false);
  const [createLeadInitialValues, setCreateLeadInitialValues] =
    useState<any>(null);
  const options = actionsOptions?.map((item) => ({ ...item, isOpen: false }));
  const [menuItems, setMenuItems] = useState<
    { value: string; id: number; isOpen: boolean }[]
  >([...options]);
  const [activeFilters, setActiveFilters] = useState<any>({});
  const [selectedLeadName, setSelectedLeadName] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const [isResetSearch, setIsResetSearch] = useState(false);
  const searchRef = useRef<{ clear: () => void }>(null);
  const [disableMassActions, setDisableMassActions] = useState<boolean>(true);
  const [selectOpen, setSelectOpen] = useState(false);
  const isSearchTriggered = useRef(false);
  const isAutoRefreshTriggered = useRef(false);
  const [resetTableSort, setResetTableSort] = useState<boolean>(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [viewTaskvalue, setViewTaskvalue] = useState({
    open: false,
    taskId: null,
  });
  const [viewMeetingvalue, setViewMeetingvalue] = useState({
    open: false,
    meetingId: null,
  });
  const [viewCallValue, setViewCallValue] = useState({
    open: false,
    callId: null,
  });
  const { tenantDetails } = useLogin();
  const filteredLeadFilterOptions = useMemo(() => {
    if (tenantDetails?.tenantType === "Tenant") {
      return filterOptions.filter((opt) => opt.labels !== "Assigned Partner");
    }
    return filterOptions;
  }, [tenantDetails, filterOptions]);
  const [selectedLeadsFilterOptions, setSelectedLeadsFilterOptions] = useState<
    any[]
  >(filteredLeadFilterOptions);

  const handleSearch = useCallback(
    _.debounce((text: string) => {
      setSearchText(text);
      isSearchTriggered.current = true;
      setCurrentPage(1);
      if (text === "") {
        setIsResetSearch(true);
        setTimeout(() => setIsResetSearch(false), 100);
      }
    }, 500),
    [],
  );

  const resetSearch = () => {
    setSearchText("");
    if (searchRef.current) {
      searchRef.current.clear();
    }
    // handleSearch("");
  };

  const userDetails = useLogin();
  const leadOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;

  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      setAlertMessage(location.state.message);
      setAlertType(location.state.type);
      setAlertOpen(true);
    }
    window.history.replaceState({}, document.title);
  }, [location.state]);

  const fetchLeads = async (
    page = 1,
    search: string = "",
    filters: any = {},
    customSortOption?: SortOption | null,
  ) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      let params: any = {
        limit: pageSize,
        offset: offset,
        leadsList: true,
      };
      const sortToUse =
        customSortOption !== undefined ? customSortOption : sortOption;
      if (sortToUse?.sortBy) {
        params = { ...params, ...sortToUse };
      }
      if (search) {
        params.searchText = search;
      }
      if (filters?.annualRevenueRange?.min) {
        params.leadValueMin = filters.annualRevenueRange.min;
      }
      if (filters?.annualRevenueRange?.max) {
        params.leadValueMax = filters.annualRevenueRange.max;
      }
      if (filters?.email) {
        params.email = filters.email;
      }
      if (filters?.city) {
        params.city = filters.city;
      }
      if (filters?.country) {
        params.country = filters.country;
      }
      if (filters?.fax) {
        params.fax = filters.fax;
      }
      if (filters?.firstName) {
        params.firstName = filters.firstName;
      }
      if (filters?.lastName) {
        params.lastName = filters.lastName;
      }
      if (filters?.company) {
        params.company = filters.company;
      }
      if (filters?.industry) {
        params.industry = filters.industry;
      }
      if (filters?.confidenceScore) {
        params.confidenceScore = filters.confidenceScore;
      }
      if (filters?.leadStatus) {
        params.leadStatus = filters.leadStatus;
      }
      if (filters?.createdTimeStart && filters.createdTimeEnd) {
        // if (filters.createdTimeStart.isSame(filters.createdTimeEnd)) {
        params.createdTimeStart = filters.createdTimeStart.startOf("day");
        params.createdTimeEnd = filters.createdTimeEnd.endOf("day");
        // } else {
        //   params.createdTimeStart = filters.createdTimeStart;
        //   params.createdTimeEnd = filters.createdTimeEnd
        // }
      }
      if (filters?.lastActivityTimeStart && filters.lastActivityTimeEnd) {
        // if (filters.lastActivityTimeStart.isSame(filters.lastActivityTimeEnd)) {
        params.lastActivityStart = filters.lastActivityTimeStart.startOf("day");
        params.lastActivityEnd = filters.lastActivityTimeEnd.endOf("day");
        // } else {
        //   params.lastActivityStart = filters.lastActivityTimeStart;
        //   params.lastActivityEnd = filters.lastActivityTimeEnd
        // }
      }
      if (filters?.createdByUserIds?.length > 0) {
        params.createdBy = filters.createdByUserIds.map(Number);
      }
      if (filters?.leadOwnerIds?.length > 0) {
        params.leadOwner = filters.leadOwnerIds.map(Number);
      }
      if (filters?.assignedPartnerIds?.length > 0) {
        params.assignedPartner = filters.assignedPartnerIds.map(Number);
      }
      const response = await getLeads(params, "Lead Details");
      setData(response.data.data.leads);
      setTotalRecords(response.data.data.totalRecords);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch campaigns",
      );
      setAlertType("error");
      setAlertOpen(true);
      setError("Failed to fetch leads list");
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!viewOpen && !isAutoRefreshTriggered.current) {
      const pageToUse = isSearchTriggered.current ? 1 : currentPage;
      fetchLeads(pageToUse, searchText, activeFilters);
      isSearchTriggered.current = false;
    }
    if (isAutoRefreshTriggered.current) {
      isAutoRefreshTriggered.current = false;
    }
  }, [currentPage, searchText, isOpen, sortOption, viewOpen, activeFilters]);

  // Auto-refresh leads every 15 seconds
  useEffect(() => {
    // Only run auto-refresh in preproduction
    const shouldAutoRefresh =
      (process.env.REACT_APP_ENV as string) === "preproduction";
    if (!shouldAutoRefresh) return;
    const autoRefreshInterval = setInterval(() => {
      if (
        !viewOpen &&
        !loading &&
        !isShowCreateLeadSection &&
        !isShowCreateLead &&
        !showImportModal &&
        !selectedActions
      ) {
        isAutoRefreshTriggered.current = true;
        setIsOpenFilter(false);
        setActiveFilters({});
        setSelectedLeadsFilterOptions(filteredLeadFilterOptions);
        resetSearch();
        setSelectedLeadsMap({});
        setSortOption({ sortBy: null, sortDirection: null });
        setResetTableSort(true); // Trigger table sort reset
        setCurrentPage(1);
        fetchLeads(1, "", {}, null);
      }
    }, 15000); // 15 seconds = 15,000 milliseconds
    // Cleanup interval on component unmount
    return () => {
      clearInterval(autoRefreshInterval);
    };
  }, [
    viewOpen,
    loading,
    isShowCreateLeadSection,
    isShowCreateLead,
    showImportModal,
    selectedActions,
  ]);

  // Reset the resetTableSort flag after it's been used
  useEffect(() => {
    if (resetTableSort) {
      const timer = setTimeout(() => {
        setResetTableSort(false);
      }, 100); // Small delay to ensure the table has processed the reset
      return () => clearTimeout(timer);
    }
  }, [resetTableSort]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setCurrentPage(value);
  };
  const [selectedLeadsMap, setSelectedLeadsMap] = useState<{
    [page: number]: number[];
  }>({});
  const isAllSelected = selectedLeadsMap[currentPage]?.length === data.length;
  const isIndeterminate =
    selectedLeadsMap[currentPage]?.length > 0 &&
    selectedLeadsMap[currentPage]?.length < data.length;
  const handleSelectAll = () => {
    setSelectedLeadsMap((prev) => {
      const currentPageLeads = data
        .filter((item) => item.lead_status !== "Closed-Won")
        .map((item) => item.id);
      const selectedLeadsOnPage = prev[currentPage] || [];

      if (selectedLeadsOnPage.length > 0) {
        return { ...prev, [currentPage]: [] };
      }
      return { ...prev, [currentPage]: currentPageLeads };
    });
  };

  const handleCheckboxChange = (id: number) => {
    setSelectedLeadsMap((prev) => {
      const prevSelected = prev[currentPage] || [];
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((leadId) => leadId !== id)
        : [...prevSelected, id];

      return {
        ...prev,
        [currentPage]: newSelected,
      };
    });
  };

  const headers = [
    {
      key: "select",
      label: (
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={handleSelectAll}
        />
      ),
    },
    { key: "leadName", label: "Lead Name", isSortable: true },
    { key: "email", label: "Email", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "leadSource", label: "Lead Source", isSortable: true },
    { key: "leadOwner", label: "Lead Owner", isSortable: true },
    { key: "leadCreatedBy", label: "Created By", isSortable: true },
    { key: "leadStatus", label: "Lead Status", isSortable: true },
  ];

  const mapColumnNameToField = (columnName: string): string => {
    const mapping: Record<string, string> = {
      leadName: "first_name",
      email: "primary_email_address",
      phone: "primary_phone_number",
      leadSource: "lead_source",
      leadOwner: "lead_owner",
      leadStatus: "lead_status",
      leadCreatedBy: "created_by",
    };

    return mapping[columnName] || columnName;
  };
  const handleSort = (column: string, sortType: string) => {
    let sortValues: SortOption = { sortBy: null, sortDirection: null };
    if (sortType !== "Unsort") {
      const mappedField = mapColumnNameToField(column);
      sortValues = { sortBy: mappedField, sortDirection: sortType };
    }
    setCurrentPage(1);
    setSortOption(sortValues);
  };

  const handleViewClick = async (leadId: number, leadName: string) => {
    setSelectedLeadId(leadId);
    setSelectedLeadName(leadName);

    setCrumbMappingOption([
      {
        label: "Lead Management",
        link: routes.LEADLIST,
        handleClick: (event: any) => {
          event.preventDefault();
          setViewTaskvalue({ open: false, taskId: null });
          setViewMeetingvalue({ open: false, meetingId: null });
          setViewCallValue({ open: false, callId: null });
          setCrumbMappingOption(breadcrumbLink); // or any logic to go home/root
          setViewOpen(false);
          setCurrentPage(1);
        },
      },
      {
        label: "Leads",
        link: routes.LEADLIST,
        handleClick: (event: any) => {
          event.preventDefault();
          setViewTaskvalue({ open: false, taskId: null });
          setViewMeetingvalue({ open: false, meetingId: null });
          setViewCallValue({ open: false, callId: null });
          setCrumbMappingOption(breadcrumbLink);
          setViewOpen(false);
          setCurrentPage(1);
        },
      },
      { label: leadName, link: "" },
    ]);

    setViewOpen(true);
  };
  const handleLeadNameUpdate = (newName: string) => {
    setSelectedLeadName(newName);
    setCrumbMappingOption((prev: any) => {
      const updated = [...prev];
      updated[2] = { ...updated[2], label: newName };
      return updated;
    });
  };

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const middleName = item?.middle_name ? item?.middle_name?.trim() : "";

    const fullName =
      firstName && lastName
        ? `${firstName} ${middleName} ${lastName}`
        : firstName
          ? firstName
          : middleName
            ? middleName
            : lastName
              ? lastName
              : "-";
    return fullName;
  };

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const firstName = item.first_name?.trim();
        const lastName = item.last_name?.trim();
        const middleName = item?.middle_name ? item?.middle_name?.trim() : "";
        const fullName =
          firstName && lastName
            ? `${firstName ? `${firstName} ` : ""}${middleName ? `${middleName} ` : ""}${lastName}`
            : firstName || middleName || lastName || "-";

        const leadName = fullName;
        const leadOwnerName = fetchFullName(item?.owner);
        const createdBy = fetchFullName(item?.createdBy);
        return {
          id: item.id,
          leadName: leadName,
          email: item.primary_email_address || "-",
          phone: item.primary_phone_number || "-",
          leadSource: item.lead_source || "-",
          leadOwner: leadOwnerName,
          leadStatus: item.lead_status || "-",
          leadCreatedBy: createdBy,
        };
      });
    }
    return [];
  }, [data, leadOwner]);

  const handleActionTrigger = (action: string) => {
    setMenuItems((prevItems) =>
      prevItems.map((item) =>
        item.value === action ? { ...item, isOpen: !item?.isOpen } : item,
      ),
    );
  };

  const checkDisableOfActionScope = () => {
    const disableScope = [{ "All Leads": true }, { "Selected Leads": true }];
    if (data?.length >= 1) disableScope[0]["All Leads"] = false;
    if (Object.values(selectedLeadsMap)?.flat(Infinity).length >= 1)
      disableScope[1]["Selected Leads"] = false;
    return disableScope;
  };

  useEffect(() => {
    if (Object.values(selectedLeadsMap)?.flat(Infinity).length >= 1) {
      setDisableMassActions(false);
    } else if (Object.values(selectedLeadsMap)?.flat(Infinity).length === 0) {
      setDisableMassActions(true);
    }
  }, [selectedLeadsMap]);

  const handleMassActionMenuClose = () => {
    if (setSelectOpen) setSelectOpen(false);
    setSelectedActions(null);
  };
  const appliedFilterCount = useMemo(() => {
    let count = 0;
    const dateFilterActive =
      activeFilters.createdTimeStart || activeFilters.createdTimeEnd;
    const runFilterActive =
      activeFilters.lastActivityTimeStart || activeFilters.lastActivityTimeEnd;

    const otherFilters = { ...activeFilters };
    delete otherFilters.createdTimeStart;
    delete otherFilters.createdTimeEnd;
    delete otherFilters.lastActivityTimeStart;
    delete otherFilters.lastActivityTimeEnd;

    const otherActiveFilters = Object.values(otherFilters).filter((val) => {
      if (val === undefined || val === "" || val === null) return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === "object") {
        return Object.values(val).some(
          (v) => v !== "" && v !== undefined && v !== null,
        );
      }
      return true;
    }).length;
    if (dateFilterActive) {
      count += 1;
    }
    if (runFilterActive) {
      count += 1;
    }

    count += otherActiveFilters;

    return count;
  }, [activeFilters]);
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  const createUpdateLeadList = () => {
    fetchLeads();
    setSearchText("");
    setActiveFilters({});
    setSelectedLeadsMap({});
    setCurrentPage(1);
    setSelectedLeads([]);
    setSelectedLeadsFilters([]);
    setSelectedLeadsFilterOptions(filterOptions);
    setSelectedAllLeads(null);
    setSelectedCreateLeads(null);
    setSelectedActions(null);
    setSortOption({ sortBy: null, sortDirection: null });
  };
  const noResultText = useMemo(() => {
    if (loading) {
      return "Loading Leads...";
    }
    if (searchText) {
      return "No leads  found matching your search criteria";
    }
    return "No leads found";
  }, [loading, searchText]);

  return (
    <>
      {isShowCreateLeadSection ? (
        isMobile ? (
          <CreateLeadResponsive
            createLeadInitialValues={createLeadInitialValues}
            setCreateLeadInitialValues={setCreateLeadInitialValues}
            setIsShowCreateLeadSection={setIsShowCreateLeadSection}
            updateLeadList={createUpdateLeadList}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        ) : (
          <CreateLead
            createLeadInitialValues={createLeadInitialValues}
            setCreateLeadInitialValues={setCreateLeadInitialValues}
            setIsShowCreateLeadSection={setIsShowCreateLeadSection}
            updateLeadList={createUpdateLeadList}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        )
      ) : (
        <div className="leadlist-wrapper">
          {/* Breadcrumb Section */}
          <div className="breadcrumb-wrapper">
            <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
          </div>

          <div style={{ display: !viewOpen ? "block" : "none" }}>
            <div>
              <LeadFilter
                isOpenFilter={isOpenFilter}
                setIsOpenFilter={setIsOpenFilter}
                selectedLeadsFilter={appliedFilterCount}
                selectedAllLeads={selectedAllLeads}
                setSelectedAllLeads={setSelectedAllLeads}
                selectedCreateLeads={selectedCreateLeads}
                setSelectedCreateLeads={setSelectedCreateLeads}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                onSearch={handleSearch}
                searchRef={searchRef}
                isResetSearch={isResetSearch}
                resetSearch={resetSearch}
                disableSelectedLeads={checkDisableOfActionScope()}
                handleActionTrigger={handleActionTrigger}
                setIsShowCreateLead={setIsShowCreateLead}
                isShowCreateLead={isShowCreateLead}
                disabled={disableMassActions}
                selectOpen={selectOpen}
                setSelectOpen={setSelectOpen}
                totalLeads={data?.length || 0}
                showImportModal={showImportModal}
                setShowImportModal={setShowImportModal}
                isShowCreateLeadSection={isShowCreateLeadSection}
                setIsShowCreateLeadSection={setIsShowCreateLeadSection}
                fetchLeads={() => {
                  setIsResetSearch(!isResetSearch);
                  setSearchText("");
                  fetchLeads(currentPage);
                }}
              />
            </div>
            {isShowCreateLead ? (
              <CreateLeadPopup
                onClose={() => {
                  setIsShowCreateLead(false);
                }}
                setCreateLeadInitialValues={setCreateLeadInitialValues}
                setIsShowCreateLeadSection={setIsShowCreateLeadSection}
                updateLeadList={createUpdateLeadList}
                setAlertMessage={setAlertMessage}
                setAlertType={setAlertType}
                setAlertOpen={setAlertOpen}
                setLoading={setLoading}
              />
            ) : (
              ""
            )}
            {/* Table Section */}
            <div className="lead-list-table-filter">
              <div
                className="lead-list-table"
                style={isOpenFilter ? { width: "80%" } : {}}
              >
                <MUITable
                  headers={headers}
                  data={formattedData.map((item) => ({
                    key: item.id,
                    select: (
                      //  <div onClick={e => e.stopPropagation()}>
                      <>
                        {item.leadStatus === "Draft" && (
                          <div className="review-icon">
                          <Tooltip title="Review" >
                              <VisibilityOutlinedIcon />
                          </Tooltip>
                          </div>
                        )}
                        {item.leadStatus !== "Draft" && (
                          <Checkbox
                            checked={
                              selectedLeadsMap[currentPage]?.includes(
                                item.id,
                              ) || false
                            }
                            onClick={(event) => event.stopPropagation()}
                            onChange={() => handleCheckboxChange(item.id)}
                            disabled={item.leadStatus === "Closed-Won"}
                            style={
                              item.leadStatus === "Closed-Won"
                                ? { cursor: "not-allowed" }
                                : {}
                            }
                          />
                        )}
                      </>

                      // </div>
                    ),
                    leadName: item.leadName,
                    email: item.email,
                    phone: item.phone,
                    leadSource: item.leadSource,
                    leadOwner: item.leadOwner,
                    leadCreatedBy: item.leadCreatedBy,
                    leadStatus: <LeadsStatus status={item.leadStatus} />,
                    disableClick: item.leadStatus === "Closed-Won",
                  }))}
                  onSort={handleSort}
                  noResultsTxt={noResultText}
                  onRowClick={(rowData: any) =>
                    handleViewClick(rowData.key, rowData.leadName)
                  }
                  resetSort={resetTableSort}
                />
              </div>
              <div
                style={{ display: isOpenFilter ? "block" : "none" }}
                className="lead-list-filter"
              >
                <LeadFilterOptions
                  isOpenFilter={isOpenFilter}
                  setIsOpenFilter={setIsOpenFilter}
                  selectedLeadsFilter={selectedLeadsFilter}
                  setSelectedLeadsFilters={setSelectedLeadsFilters}
                  selectedLeadsFilterOptions={selectedLeadsFilterOptions}
                  setAlertMessage={setAlertMessage}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                  setSelectedLeadsFilterOptions={setSelectedLeadsFilterOptions}
                  onApplyFilters={(filters: any) => {
                    setCurrentPage(1);
                    setActiveFilters(filters);
                  }}
                  activeFilters={activeFilters}
                />
              </div>
            </div>
            {totalRecords && totalRecords > 0 ? (
              <div
                className="leads-pagination-container"
                style={{
                  pointerEvents: showImportModal ? "none" : "auto",
                  opacity: showImportModal ? 0.5 : 1,
                }}
              >
                <PaginationComponent
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          {!viewOpen ? (
            ""
          ) : (
            <LeadView
              setLoading={setLoading}
              selectedLeadId={selectedLeadId}
              onLeadNameUpdate={handleLeadNameUpdate}
              setViewTaskvalue={setViewTaskvalue}
              viewTaskvalue={viewTaskvalue}
              setViewMeetingvalue={setViewMeetingvalue}
              viewMeetingvalue={viewMeetingvalue}
              setCrumbMappingOption={setCrumbMappingOption}
              setViewCallValue={setViewCallValue}
              viewCallValue={viewCallValue}
            />
          )}
          <LeadActionHandler
            selectedLeadsMap={selectedLeadsMap}
            setSelectedLeadsMap={setSelectedLeadsMap}
            selectedActions={selectedActions}
            setSelectedActions={setSelectedActions}
            menuItems={menuItems}
            setMenuItems={setMenuItems}
            fetchLeads={() => {
              if (searchText) resetSearch();
              if (currentPage === 1) fetchLeads();
              else setCurrentPage(1);
            }}
            selectedLeadActionScope={selectedLeadActionScope}
            setselectedLeadActionScope={setselectedLeadActionScope}
            totalRecords={totalRecords}
            handleMassActionMenuClose={handleMassActionMenuClose}
            leadsData={data}
          />
        </div>
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default LeadList;
